export class MessageCenter {
  constructor() {
    this.channels = {};
  }

  subscribe(channel, type, handler) {
    const channels = this.channels;
    const types = channels[channel] || (channels[channel] = {});
    const handlers = types[type] || (types[type] = []);
    handlers.push(handler);
    return () => {
      const handlers = (types[type] = types[type].filter((o) => o !== handler));
      if (handlers.length < 1) {
        delete types[type];
        if (Object.keys(types).length < 1) {
          delete channels[channel];
        }
      }
    };
  }

  send(channel, type, payload) {
    const types = this.channels[channel];
    if (!types) {
      return;
    }

    const handlers = types[type];
    if (!handlers || handlers.length < 1) {
      return;
    }

    handlers.forEach((handler) => handler.apply(null, [payload]));
  }
}
